"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Label = require("../primitive/Label");
var _excluded = ["variant", "error", "children", "className"];
var RadioLabel = function RadioLabel(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    error = _ref.error,
    children = _ref.children,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, {
    hasError: !!error,
    variant: variant,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(HiddenRadio, Object.assign({}, props, {
    type: "radio"
  })), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    variant: "regular",
    htmlFor: props.id,
    radioVariant: variant
  }, children)), error && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], null, error));
};
var _default = exports["default"] = RadioLabel;
var HiddenRadio = _styledComponents["default"].input.attrs(function () {
  return {
    type: 'radio'
  };
}).withConfig({
  displayName: "RadioLabel__HiddenRadio",
  componentId: "sc-a08xqu-0"
})(["position:absolute;opacity:0;"]);
var StyledLabel = (0, _styledComponents["default"])(_Label.Label).withConfig({
  displayName: "RadioLabel__StyledLabel",
  componentId: "sc-a08xqu-1"
})(["font-weight:400;z-index:1;font-family:", ";color:", ";border-radius:24px;text-align:center;pointer-events:none;padding:0.4rem 1.6rem;display:block;", " ", " ", ":disabled ~ &{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.body;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral['100'];
}, function (_ref4) {
  var radioVariant = _ref4.radioVariant,
    theme = _ref4.theme;
  return radioVariant === 'default' && "background-color: ".concat(theme.colors.neutral['10'], ";\n        border: 0.1rem solid ").concat(theme.colors.neutral['10'], ";\n    ");
}, function (_ref5) {
  var radioVariant = _ref5.radioVariant,
    theme = _ref5.theme;
  return radioVariant === 'primary' && "border: 0.1rem solid ".concat(theme.colors.neutral['20'], ";\n    ");
}, HiddenRadio, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.neutral['30'];
});
var Container = _styledComponents["default"].label.withConfig({
  displayName: "RadioLabel__Container",
  componentId: "sc-a08xqu-2"
})(["", ":checked + ", "{", " ", "}"], HiddenRadio, StyledLabel, function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  return variant === 'default' && "background-color: ".concat(theme.colors.neutral['0'], ";\n        border-color: ").concat(theme.colors.neutral['40'], ";");
}, function (_ref8) {
  var variant = _ref8.variant,
    theme = _ref8.theme;
  return variant === 'primary' && "background-color: ".concat(theme.colors.primary['80'], ";\n        border: 0.1rem solid ").concat(theme.colors.primary['80'], ";\n        color: ").concat(theme.colors.neutral['0'], "\n    ");
});
//# sourceMappingURL=RadioLabel.js.map